<template>
  <main>
    <div><proposal-banner></proposal-banner></div>
    <div><proposal-banner :isError="true"></proposal-banner></div>
    <div class="field">
      <div class="tag-text">
        <p class="p1">Title</p>
      </div>
      <text-field v-model="title" :error="titleError" />
    </div>

    <div class="field">
      <div class="tag-text">
        <p class="p1">Brief Summary</p>
      </div>
      <text-area rows="2" v-model="briefSummary" :error="briefSummaryError" />
    </div>

    <div class="field">
      <div class="tag-text">
        <p class="p1">Proposal Description</p>
        <p class="p2">
          Why you think this is important or could benefit the DAO
        </p>
      </div>
      <text-area type="textarea" v-model="proposalDescription" :error="proposalDescriptionError" />
    </div>

    <div class="field">
      <div class="tag-text">
        <p class="p1">Rationale</p>
        <p class="p2">
          Why you think this is important or could benefit the DAO
        </p>
      </div>
      <text-area rows="2" v-model="rationale" :error="rationaleError" />
    </div>
    <div class="field">
      <div class="tag-text">
        <p class="p1">Implementation Plan</p>
        <p class="p2">
          How you plan to do the necessary work, resources, team involved etc.
        </p>
      </div>
      <text-area rows="2" v-model="implementationPlan" :error="implementationPlanError" />
    </div>
    <div class="field">
      <div class="tag-text">
        <p class="p1">Timeline</p>
        <p class="p2">
          Days, weeks or month for the proposal or each step in the proposal
        </p>
      </div>
      <text-area rows="2" v-model="timeline" :error="timelineError" />
    </div>

    <div class="field">
      <div class="tag-text">
        <p class="p1">Expected Outcomes</p>
        <p class="p2">What will be the end result and next steps</p>
      </div>
      <text-area rows="2" v-model="expectedOutcomes" :error="expectedOutcomesError" />
    </div>
    <div class="field">
      <div class="tag-text">
        <p class="p1">Total Request Amount ($VIBES)</p>
      </div>
      <text-field type="number" v-model="totalAmount" :isRightText="true" rightText="$VIBES" :error="totalAmountError" />
    </div>

    <div class="field">
      <div class="tag-text">
        <p class="p1">Initial Request %</p> <p class="p2">Amount required before work begins - to be distributed upon approval</p>
      </div>
      <text-field v-model="initialRequest" :error="initialRequestError"  />
    </div>

    <div class="container">
      <div class="text-container"><p class="p1">Total Request amount</p><p class="amount-text">{{this.totalAmountDisplay}} $VIBES</p></div>
      <div class="text-container"><p class="p1">Initial Request amount - to be distributed upon approval</p><p class="amount-text">{{this.initialPercentage}} $VIBES</p></div>
      <div class="text-container"><p class="p1">Remaining amount - to be distributed upon completion of work*</p><p class="amount-text">{{this.remainingAmount}} $VIBES</p></div>
    </div>

      <p class="caption">*Satisfactory completion of work will be determined by a nominated council. Any disputes will be handled by 3rd party. By clicking Submit Proposal you are agreeing to these terms. See <span class="here">here</span> for more info.</p>

  </main>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TextArea from '../general/text-area.vue'
import TextField from '../general/text-field.vue'
import ProposalBanner from './proposal-banner.vue'

import {calculatePercentage, usThousandFormat} from '../../helpers/general-helpers'

export default {
  name: 'CreateProposal',
  props: {
    isCreate: {
      type: Boolean,
      default: false
    }
  },
  components: { TextArea, TextField, ProposalBanner },
  computed: {
    ...mapState('daoCommunity', {
      formTitle: 'title',
      formBriefSummary: 'briefSummary',
      fromProposalDescription: 'proposalDescription',
      formRationale: 'rationale',
      formImplementationPlan: 'implementationPlan',
      formTimeline: 'timeline',
      formExpectedOutcomes: 'expectedOutcomes',
      formTotalAmount: 'totalAmount',
      formInitialRequest: 'initialRequest'
    }),
    ...mapState('daoCommunity', ['titleError',
      'briefSummaryError',
      'proposalDescriptionError',
      'rationaleError',
      'implementationPlanError',
      'timelineError',
      'expectedOutcomesError',
      'totalAmountError',
      'initialRequestError']),
    title: {
      get () {
        return this.formTitle
      },
      set (value) {
        if (value.trim().length > 0) {
          this.setTitleError(null)
        }
        return this.setTitle(value)
      }
    },
    briefSummary: {
      get () {
        return this.formBriefSummary
      },
      set (value) {
        if (value.trim().length > 0) {
          this.setBriefSummaryError(null)
        }
        return this.setBriefSummary(value)
      }
    },
    proposalDescription: {
      get () {
        return this.fromProposalDescription
      },
      set (value) {
        if (value.trim().length > 0) {
          this.setProposalDescriptionError(null)
        }
        return this.setProposalDescription(value)
      }
    },
    rationale: {
      get () {
        return this.formRationale
      },
      set (value) {
        if (value.trim().length > 0) {
          this.setRationaleError(null)
        }
        return this.setRationale(value)
      }
    },
    implementationPlan: {
      get () {
        return this.formImplementationPlan
      },
      set (value) {
        if (value.trim().length > 0) {
          this.setImplementationPlanError(null)
        }
        return this.setImplementationPlan(value)
      }
    },
    timeline: {
      get () {
        return this.formTimeline
      },
      set (value) {
        if (value.trim().length > 0) {
          this.setTimelineError(null)
        }
        return this.setTimeline(value)
      }
    },
    expectedOutcomes: {
      get () {
        return this.formExpectedOutcomes
      },
      set (value) {
        if (value.trim().length > 0) {
          this.setExpectedOutcomesError(null)
        }
        return this.setExpectedOutcomes(value)
      }
    },
    totalAmount: {
      get () {
        return this.formTotalAmount
      },
      set (value) {
        if (value.trim().length > 0) {
          this.setTotalAmountError(null)
        }
        return this.setTotalAmount(value)
      }
    },
    initialRequest: {
      get () {
        return this.formInitialRequest
      },
      set (value) {
        if (value.trim().length > 0) {
          this.setInitialRequestError(null)
        }
        return this.setInitialRequest(value)
      }
    },
    remainingAmount () {
      if (!this.formTotalAmount) { return 0 }
      return usThousandFormat(calculatePercentage(parseInt(this.formTotalAmount), 100 - this.formInitialRequest))
    },
    initialPercentage () {
      if (!this.formTotalAmount) { return 0 }
      return usThousandFormat(calculatePercentage(parseInt(this.formTotalAmount), parseInt(this.formInitialRequest)))
    },
    totalAmountDisplay () {
      return usThousandFormat(this.formTotalAmount)
    }
  },
  watch: {
  },
  methods: {
    ...mapMutations('daoCommunity', ['setTitleError', 'setBriefSummaryError', 'setProposalDescriptionError', 'setRationaleError', 'setImplementationPlanError', 'setTimelineError', 'setExpectedOutcomesError', 'setTotalAmountError', 'setInitialRequestError']),
    onEditorChange () {
      this.setDescription(this.$refs.toastuiEditor.invoke('getMarkdown'))
    },
    onChangeType (v) {
      const reward = this.jobTypesReward[v]
      this.reward = reward
      this.setRewardPercentage(reward)
      this.setTypeId(v)
    },
    ...mapMutations('daoCommunity', [
      'setTitle',
      'setBriefSummary',
      'setProposalDescription',
      'setRationale',
      'setImplementationPlan',
      'setTimeline',
      'setExpectedOutcomes',
      'setTotalAmount',
      'setInitialRequest'
    ])
  },
  mounted () {
    this.$once('hook:beforeDestroy', () => {
      this.clear()
    })
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.tag-text {
  display: flex;
  margin-bottom: 5px;
}
@media (max-width: 760px) {
  flex-direction: column;
}
.p1 {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;

  color: #080808;
  margin-right: 5px;
}

.p2 {
  font-weight: 400;
  font-size: 12px;
  font-style: italic;
  line-height: normal;
  color: #979797;
  margin-top: 3px;
}

.text-container{
  display: flex;
  justify-content: space-between;
}

.container{
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.amount-text{
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.caption{
  margin-top: 20px;
  font-size: 10px;
  font-style: normal;
  line-height: normal;
}

.here{
  color: #31E5FF;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/dao-community/create-proposal-form.vue